import script from "./alarmRule.vue?vue&type=script&setup=true&lang=js"
export * from "./alarmRule.vue?vue&type=script&setup=true&lang=js"

import "./alarmRule.vue?vue&type=style&index=0&id=dfcd8e8e&lang=less"

const __exports__ = script;

export default __exports__